module.exports = __webpack_public_path__ + "static/pokoj-nr4-photo01-miniaturka-09925e6b831a96c233d508158e605cf3.jpg";